<template>
    <div id="themeStep">
        <div class="theme-step-container">
            <div class="theme-body">
                <div class="mini-stepper">
                    <MiniStepper :active-index="activeIndex" @changeStep="changeMiniStepHandler" :count="3" />
                </div>
                <div class="step-1" v-if="activeIndex === 0">
                    <div class="title">{{ $t("newWizartV2.readytemplate") }}</div>
                    <div class="themes">
                        <div
                            v-for="theme in themes"
                            :key="theme.name"
                            @click="themeSelectHandler(theme.name)"
                            class="theme-item"
                            :style="{ backgroundColor: theme.color }"
                        >
                            <md-icon v-if="selectedTheme === theme.name">done</md-icon>
                        </div>
                    </div>
                    <div class="options">
                        <div class="platforms platforms-container">
                            <div class="platform platform-content" :class="{ selected: features === 'Instructions' }">
                                <div
                                    class="fw-header"
                                    @click="features = features === 'Instructions' ? null : 'Instructions'"
                                >
                                    <h4 class="title">{{ $t("newWizartV2.customSettings") }}</h4>
                                    <span class="down-arrow">&#x2193;</span>
                                </div>
                                <div class="content" v-show="features === 'Instructions'">
                                    <div class="customer-balloon">
                                        <div class="sub-title">{{ $t("newWizartV2.customerMessageView") }}</div>
                                        <div class="plan">
                                            <div class="option">
                                                <div class="option-name">{{ $t("newWizartV2.backcgroundColor") }}</div>
                                                <input type="color" id="c1" v-model="customerBubbleColor" />
                                            </div>
                                            <div class="option">
                                                <div class="option-name">{{ $t("newWizartV2.textColor") }}</div>
                                                <input type="color" id="c1" v-model="customerTextColor" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="representative-balloon">
                                        <div class="sub-title">{{ $t("newWizartV2.agentMessageView") }}</div>
                                        <div class="plan">
                                            <div class="option">
                                                <div class="option-name">{{ $t("newWizartV2.backcgroundColor") }}</div>
                                                <input type="color" id="r1" v-model="representativeBubbleColor" />
                                            </div>
                                            <div class="option">
                                                <div class="option-name">{{ $t("newWizartV2.textColor") }}</div>
                                                <input type="color" id="r2" v-model="representativeTextColor" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="next-button" @click="nextButtonClickHandler">
                                        {{ $t("fastWizard.continue") }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="step-2" v-if="activeIndex === 1">
                    <div class="options">
                        <div class="customer-balloon">
                            <div class="sub-title">{{ $t("theme.textColor") }}</div>
                            <div class="plan">
                                <div class="option">
                                    <div class="option-name">{{ $t("newWizartV2.textColor") }}</div>
                                    <input type="color" id="c1" v-model="textColor" />
                                </div>
                            </div>
                        </div>
                        <div class="representative-balloon">
                            <div class="sub-title">{{ $t("fastWizard.generalColors") }}</div>
                            <div class="plan">
                                <div class="option">
                                    <div class="option-name">{{ $t("newWizartV2.backcgroundColor") }}</div>
                                    <input type="color" id="r1" v-model="backgroundColorFirst" />
                                </div>
                                <div class="option">
                                    <div class="option-name">{{ $t("message.titleColor") }}</div>
                                    <input type="color" id="r2" v-model="headerColorFirst" />
                                </div>
                                <div class="option display">
                                    <div class="option-name">{{ $t("message.secondTitleColor") }}</div>
                                    <input type="color" id="r2" v-model="headerColorSecond" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="next-button" @click="nextButtonClickHandler">{{ $t("newWizartV2.goToNextStep") }}</div>
                </div>
                <div class="step-3" v-if="activeIndex === 2">
                    <div class="title">{{ $t("fastWizard.selectBubble") }}</div>
                    <div class="baloons">
                        <span @click="() => changeBubbleWithIndex('1')"><Bubble1 /></span>
                        <span @click="() => changeBubbleWithIndex('2')"><Bubble2 /></span>
                        <span @click="() => changeBubbleWithIndex('3')"><Bubble3 /></span>
                        <span @click="() => changeBubbleWithIndex('4')"><Bubble4 /></span>
                        <span @click="() => changeBubbleWithIndex('5')"><Bubble5 /></span>
                        <span @click="() => changeBubbleWithIndex('6')"><Bubble6 /></span>
                        <span @click="() => changeBubbleWithIndex('7')"><Bubble7 /></span>
                    </div>
                    <div class="sub-title">{{ $t("chatbotv2.chatbotLogo") }}</div>
                    <div class="add-logo">
                        <div class="upload-button" @click="uploadBubble">+</div>
                        <div class="added-logo" v-if="newIcon || (!!settings.bubble && !!settings.bubble.customIcon)">
                            <img
                                :src="bubbleIcon"
                                alt="bubble"
                                style="width: 100px; height: 100px; object-fit: contain"
                            />
                        </div>
                    </div>
                    <div class="sub-title">{{ $t("fastWizard.selectChatBubbleColor") }}</div>
                    <div class="plan">
                        <div class="option">
                            <div class="option-name">{{ $t("fastWizard.chatBubbleColor") }}</div>
                            <input type="color" id="c1" v-model="bubbleColor" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeIndex === 0 || activeIndex === 1" class="visitor-demo">
            <DemoVisitor />
        </div>
        <div v-else class="visitor-demo">
            <live-preview />
        </div>
    </div>
</template>

<script>
import DemoVisitor from "../../components/DemoVisitor.vue";
import MiniStepper from "./MiniStepper.vue";
import { mapActions, mapState } from "vuex";
import * as _ from "lodash";
import { sendSocketMessage } from "../../utils/socketStream";
import { log2 } from "../../utils/log2";
import { preConfiguredThemesV2 } from "../../utils/chatTheme";
import { getExtensionFromFileName } from "../../utils/utils";
import { uploadAsset } from "../../api/assetUpload";
import mimeTypes from "../util/mimeTypes";
import axios from "axios";
import WordPressIcon from "../fast-initialize/svg/WordPressIcon.vue";
import OpenCartIcon from "../fast-initialize/svg/OpenCartIcon.vue";
import TicimaxIcon from "../fast-initialize/svg/TicimaxIcon.vue";
import JSIcon from "../fast-initialize/svg/JSIcon.vue";
import ShopifyIcon from "../fast-initialize/svg/ShopifyIcon.vue";
import EticaretteyimIcon from "../fast-initialize/svg/EticaretteyimIcon.vue";
import DisplayConfig from "../fast-initialize/DisplayConfig.vue";
import Bubble1 from "../svg/bubbles/Bubble1.vue";
import Bubble2 from "../svg/bubbles/Bubble2.vue";
import Bubble3 from "../svg/bubbles/Bubble3.vue";
import Bubble4 from "../svg/bubbles/Bubble4.vue";
import Bubble5 from "../svg/bubbles/Bubble5.vue";
import Bubble6 from "../svg/bubbles/Bubble6.vue";
import Bubble7 from "../svg/bubbles/Bubble7.vue";
import LivePreview from "../fast-initialize/LivePreview.vue";

const log = log2("Settings");

export default {
    name: "ThemeStep",
    components: {
        EticaretteyimIcon,
        ShopifyIcon,
        JSIcon,
        TicimaxIcon,
        OpenCartIcon,
        DisplayConfig,
        WordPressIcon,
        MiniStepper,
        DemoVisitor,
        LivePreview,
        Bubble1,
        Bubble2,
        Bubble3,
        Bubble4,
        Bubble5,
        Bubble6,
        Bubble7,
    },
    data() {
        return {
            features: null,
            activeIndex: 0,
            themes: [
                { name: "orange", color: "#F3643B" },
                { name: "black", color: "#000" },
                { name: "blue", color: "#248DF5" },
                { name: "green", color: "#62AD46" },
                { name: "yellow", color: "#EA941F" },
                { name: "red", color: "#d32f2f" },
                { name: "pink", color: "#f48fb1" },
                { name: "purple", color: "#8e24aa" },
                { name: "mango", color: "#ff9800" },
                { name: "servquick", color: "#707070" },
            ],
            selectedTheme: "orange",
            handleSave: _.debounce((newSettings) => {
                const isValid = Date.now() - (this.mountedTime || Date.now()) > 2000; // defaulttan gerçeğe geçerken bir kere sunucuya gitmesini engellemek için alternatif başka çözüm var sa yapalım
                log("handleSave runned", {
                    newSettings,
                    initialized: this.settingInitialized,
                    isValid,
                    mountedTime: this.mountedTime,
                    diff: Date.now() - (this.mountedTime || Date.now()),
                });
                if (isValid) {
                    this.submitClicked = true;
                    const self = this;
                    this.$validator.validateAll().then((response) => {
                        if (response) {
                            self.updateSettings(newSettings)
                                .then(() => {
                                    sendSocketMessage("admin settings-updated", {
                                        siteId: self.site._id,
                                    });
                                })
                                .finally(() => {
                                    self.submitClicked = false;
                                });
                        } else {
                            self.$toasted.error(self.$t("message.settingFormWrong"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        }
                    });
                }
            }, 1000).bind(this),
            baloons: ["btn1", "btn2", "btn3", "btn4", "btn5", "btn6"],
            selectedBaloons: 0,
            newIcon: null,
        };
    },
    methods: {
        ...mapActions({
            setSettingValue: "setting/setSettingValue",
            updateSettings: "setting/updateSettings",
        }),
        changeMiniStepHandler(step) {
            this.activeIndex = step;
        },
        nextButtonClickHandler() {
            this.activeIndex = this.activeIndex + 1;
        },
        setValue(key, value) {
            if (!this.settingInitialized) {
                log.warn("setValue", "setting not initialized", { key, value });
                return;
            }
            const newSettings = this.setSettingValue({
                setting: key,
                value,
            });
            log("setValue debugxxx", { key, value });
            if (newSettings.then) {
                newSettings.then((x) => this.handleSave(x));
            } else {
                this.handleSave(newSettings);
            }
        },
        themeSelectHandler(selectedTheme) {
            this.selectedTheme = selectedTheme;
            const themeValue = preConfiguredThemesV2[selectedTheme];
            this.setValue("chatCustomizationSettings.preferredThemeColor", selectedTheme);
            Object.keys(themeValue).map((colorKey, index) => {
                this.setValue(`chatCustomizationSettings.versionV2Theme.colors.${colorKey}`, themeValue[colorKey]);
            });
        },
        uploadReadyBubble() {},
        uploadBubble() {
            let fileEl = document.createElement("input");
            fileEl.setAttribute("type", "file");
            let self = this;
            fileEl.onchange = async () => {
                let file = fileEl.files[0];
                if (this.beforeUpload(file)) {
                    const fileType = getExtensionFromFileName(file.name);
                    let path = `${this.site._id}/chatBubble/`;
                    let { data } = await uploadAsset({
                        path,
                        mime: file.type,
                        name: file.name,
                        ext: mimeTypes[file.type] || fileType || "supsis",
                        size: file.size,
                        type: "other"
                    });
                    await axios({
                        method: data.method,
                        url: data.url,
                        data: file,
                    });
                    const newSettings = this.setSettingValue({
                        setting: "bubble.customIcon",
                        value: data.asset._id,
                    });
                    log("selectFile debugxxx");
                    if (newSettings.then) {
                        newSettings.then((x) => this.handleSave(x));
                    } else {
                        this.handleSave(newSettings);
                    }
                    self.selectBubble();
                    self.newIcon = data.asset;
                } else {
                    log.warn("input is not suitable for send");
                    this.$toasted.error(this.$t("message.assetOversizeWithExt"), {
                        duration: 3000,
                        position: "bottom-center",
                    });
                }
            };
            fileEl.click();
        },
        selectBubble(index) {
            this.selectedBaloons = index;
            const newSettings = this.setSettingValue({
                setting: "bubble.preDefined",
                value: index + 9,
            });
            log("selectBubble debugxxx");
            if (newSettings.then) {
                newSettings.then((x) => this.handleSave(x));
            } else {
                this.handleSave(newSettings);
            }
            this.$bvModal.hide("bubble-icon-modal");
        },
        beforeUpload(file) {
            const testImgFile = /^image\/(jpg|jpeg|png)$/.test(file.type);
            const testSize = file.size <= 20 * 1024 * 1024;
            return testImgFile && testSize;
        },
        async changeBubbleWithIndex(index) {
            log("changeBubbleWithIndex", index);
            const newSettings = await this.setSettingValue({
                setting: "bubble.preDefined",
                value: index,
            });

            this.applySettings(newSettings);
        },
        applySettings(newSettings) {
            log("applySettings", newSettings);
            this.updateSettings(newSettings).then(() => {
                sendSocketMessage("user settings-updated", {
                    siteId: this.site._id,
                });
            });
        },
    },
    computed: {
        ...mapState({
            allThemeColors: (state) => state.setting.allThemeColors,
            settings: (state) => state.setting.settings,
            settingInitialized: (state) => state.setting.initialized,
            site: (state) => state.site.site,
            bubbleIcon() {
                let { customIcon } = this.settings.bubble;
                if (this.newIcon || customIcon) {
                    let asset = this.newIcon || customIcon;
                    return asset.v2Format && asset.cdnUrl
                        ? asset.cdnUrl
                        : `https://static.supsis.live/${asset.path + asset._id}${asset.ext ? "." + asset.ext : ""}`;
                }
                return undefined;
            },
        }),
        headerColorFirst: {
            get() {
                return (
                    this.settings.chatCustomizationSettings.versionV2Theme.colors.headerColorFirst || "#000000"
                ).substring(0, 7);
            },
            set(value) {
                this.setValue("chatCustomizationSettings.versionV2Theme.colors.headerColorFirst", value);
            },
        },
        headerColorSecond: {
            get() {
                return (
                    this.settings.chatCustomizationSettings.versionV2Theme.colors.headerColorSecond || "#000000"
                ).substring(0, 7);
            },
            set(value) {
                this.setValue("chatCustomizationSettings.versionV2Theme.colors.headerColorSecond", value);
            },
        },
        backgroundColorFirst: {
            get() {
                return (
                    this.settings.chatCustomizationSettings.versionV2Theme.colors.backgroundColorFirst || "#000000"
                ).substring(0, 7);
            },
            set(value) {
                this.setValue("chatCustomizationSettings.versionV2Theme.colors.backgroundColorFirst", value);
            },
        },
        textColor: {
            get() {
                return (this.settings.chatCustomizationSettings.versionV2Theme.colors.textColor || "#000000").substring(
                    0,
                    7
                );
            },
            set(value) {
                this.setValue("chatCustomizationSettings.versionV2Theme.colors.textColor", value);
            },
        },
        customerTextColor: {
            get() {
                return (
                    this.settings.chatCustomizationSettings.versionV2Theme.colors.customerTextColor || "#ffffff"
                ).substring(0, 7);
            },
            set(value) {
                this.setValue("chatCustomizationSettings.versionV2Theme.colors.customerTextColor", value);
            },
        },
        customerBubbleColor: {
            get() {
                return (
                    this.settings.chatCustomizationSettings.versionV2Theme.colors.customerBubbleColor || "#ffffff"
                ).substring(0, 7);
            },
            set(value) {
                this.setValue("chatCustomizationSettings.versionV2Theme.colors.customerBubbleColor", value);
            },
        },
        representativeBubbleColor: {
            get() {
                return (
                    this.settings.chatCustomizationSettings.versionV2Theme.colors.representativeBubbleColor || "#ffffff"
                ).substring(0, 7);
            },
            set(value) {
                this.setValue("chatCustomizationSettings.versionV2Theme.colors.representativeBubbleColor", value);
            },
        },
        representativeTextColor: {
            get() {
                return (
                    this.settings.chatCustomizationSettings.versionV2Theme.colors.representativeTextColor || "#000000"
                ).substring(0, 7);
            },
            set(value) {
                this.setValue("chatCustomizationSettings.versionV2Theme.colors.representativeTextColor", value);
            },
        },
        bubbleColor: {
            get() {
                return (this.settings.bubble && this.settings.bubble.bubbleColor) || "#000000";
            },
            set(value) {
                this.setValue("bubble.bubbleColor", value);
            },
        },
    },
    mounted() {
        this.mountedTime = Date.now();
        this.setValue("chatCustomizationSettings.isVersionV2", true);
    },
};
</script>

<style scoped lang="scss">
#themeStep {
    background-color: white;
    padding-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.theme-step-container {
    width: 100%;
    margin-right: 0;
    display: block;
}

.theme-body {
    margin-left: 0;
    margin-bottom: 30px;
    background-color: white;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 25px;
    padding: 10px;
    width: 60%;
    margin: auto;
}

.step-1,
.step-2,
.step-3 {
    .title {
        font-size: 22px;
        font-weight: bold;
        line-height: 24px;
        font-style: normal;
        color: #141821;
        margin: 30px;
    }

    .sub-title {
        font-size: 19px;
        font-weight: bold;
        line-height: 24px;
        font-style: normal;
        color: #141821;
        margin: 30px;
    }

    .themes {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
        padding: 0px 10px;
        width: 90%;
        margin: 0 auto;
        gap: 14px;

        .theme-item {
            width: 100px;
            height: 60px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            user-select: none;

            i {
                font-size: 35px !important;
                color: white !important;
            }
        }
    }

    .options {
        .platforms-container {
            padding-top: 20px;
        }

        .platform-content {
            border: 1px solid #e6e6e6;
            border-radius: 4px;
            margin-bottom: 10px;
            background: #fff;
        }

        .plan {
            display: flex;
            justify-content: space-evenly;
            align-items: center;

            .option {
                display: flex;
                align-items: center;

                .option-name {
                    margin-right: 10px;
                }

                input {
                    -webkit-appearance: none;
                    padding: 0;
                    border: 1px solid #b4b4b4;
                    border-radius: 50%;
                    width: 30px;
                    height: 30px;
                    box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.1);
                    cursor: pointer;

                    &::-webkit-color-swatch {
                        border: none;
                        border-radius: 50%;
                        padding: 0;
                    }

                    &::-webkit-color-swatch-wrapper {
                        border: none;
                        border-radius: 50%;
                        padding: 0;
                    }
                }
            }
        }

        .customer-balloon,
        .representative-balloon {
            .plan {
                .option {
                    .option-name {
                    }

                    input {
                    }
                }
            }
        }
    }

    .next-button {
        width: 100%;
        max-width: 300px;
        margin: 0 auto;
        background-color: #ec4b1d;
        padding: 10px;
        border-radius: 7px;
        align-items: center;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
        margin-top: 50px;
        margin-bottom: 10px;
        text-align: center;
        cursor: pointer;
        user-select: none;

        &:hover {
            background-color: #c54018;
        }
    }
}

.step-2 {
    .next-button {
        margin-top: 20px;
    }
}

.step-3 {
    .baloons {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(65px, 1fr));
        gap: 16px;

        .item {
            display: flex;
            width: 65px;
            height: 65px;
            cursor: pointer;
            user-select: none;
            justify-content: center;
            align-items: center;
            border-radius: 50%;

            &.active {
                border: 1px solid black;
            }
        }
    }

    .add-logo {
        display: flex;
        align-items: center;

        .upload-button {
            color: white;
            border-radius: 50%;
            display: flex;
            text-align: center;
            justify-content: center;
            align-items: center;
            font-size: 27px;
            font-weight: bold;
            background-color: #ec4b1d;
            width: 40px;
            height: 40px;
            cursor: pointer;
            user-select: none;
        }

        .added-logo {
            margin-left: 50px;
        }
    }

    .plan {
        margin-bottom: 30px;

        .option {
            display: flex;
            align-items: center;

            .option-name {
                margin-right: 10px;
            }

            input {
                -webkit-appearance: none;
                padding: 0;
                border: 1px solid #b4b4b4;
                border-radius: 50%;
                width: 30px;
                height: 30px;
                box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.1);
                cursor: pointer;

                &::-webkit-color-swatch {
                    border: none;
                    border-radius: 50%;
                    padding: 0;
                }

                &::-webkit-color-swatch-wrapper {
                    border: none;
                    border-radius: 50%;
                    padding: 0;
                }
            }
        }
    }
}

.visitor-demo {
    padding: 0 50px 150px;
}

.fw-header {
    display: flex;
    justify-content: center;
    align-items: center;

    span {
        font-size: 20px;
        font-weight: bold;
        color: rgb(243, 100, 59);
        margin-left: 10px;
    }
}

@media (max-width: 768px) {
    #themeStep {
        display: block;
        padding-bottom: 150px;
    }
    .theme-step-container {
        width: 100%;
        margin-right: 0;
        display: block;

        .theme-body {
            width: 100%;
            margin-left: 0;
        }
    }
    .visitor-demo {
        margin-top: 20px;
        padding: 0 50px 0px;
    }
    .display {
        display: none !important;
    }
}

.theme-item {
    width: 100px;
    height: 60px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    user-select: none;

    i {
        font-size: 35px !important;
        color: white !important;
    }
}
</style>
